import { Button } from "@/components/ui/button";
import type { ShopNowButtonBlockV2 } from "@lib/config/types";
import {
  type FontFamily,
  alignStyle,
  boxShadow,
  resolveFontFamilyVariables,
} from "@lib/utils";
import { useLocation, useLoaderData } from "@tanstack/react-router";

type ShopNowButtonProps = ShopNowButtonBlockV2;

const purchaseQs = "?origin=review_flow&sp_tracking_id=";

export function ShopNowButton({ shop_now_button: button }: ShopNowButtonProps) {
  const location = useLocation();
  const isReview = location.pathname.startsWith("/flow/review");
  const loader = useLoaderData({ strict: false });

  const url =
    button.url +
    (isReview && loader?.encodedOrderId
      ? purchaseQs + loader?.encodedOrderId
      : "");

  const isInIFrame =
    typeof window !== "undefined" && window.self !== window.top;
  const target = isInIFrame ? "_top" : undefined;

  const fontFamily = button.font as FontFamily;
  return (
    <div
      data-block-type="Submit Button"
      style={{
        ...resolveFontFamilyVariables(
          "--button",
          fontFamily,
          button.font_properties,
        ),
        fontStyle: "var(--button-font-style)",
        fontWeight: "var(--button-font-weight)",
      }}
    >
      <Button
        asChild
        className="px-8 py-0 w-min"
        style={{
          ...alignStyle(button),
          width: button.width === "full" ? "100%" : "min-content",
          height: `${button.height}px`,
          color: button.color,
          backgroundColor: button.background_color,
          borderRadius:
            button.border.radius === 9999
              ? "9999em"
              : `${button.border.radius}px`,
          border: `${button.border.width}px solid ${button.border.color}`,
          fontSize: button.font_size,
          fontFamily: "var(--button-font-name)",
          fontWeight: "var(--button-font-weight)",
          letterSpacing: button.letter_spacing,
          boxShadow: boxShadow(button.shadow),
        }}
      >
        <a
          href={url}
          className="no-underline"
          target={target}
          rel={target ? "noopener noreferrer" : undefined}
        >
          {button.text}
        </a>
      </Button>
    </div>
  );
}
